
export class SimpleRefrigeration {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new SimpleRefrigeration(
      this.hash,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/simple-refrigeration.ts